import { apiClient } from '@/http/apiClient';
import User from '@/models/User';
import { AxiosInstance } from 'axios';
import { BootstrapVue,IconsPlugin } from 'bootstrap-vue';
import moment from 'moment';
import velocity from 'velocity-animate';
import Vue from 'vue';
import 'vue-editable-grid/dist/VueEditableGrid.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// notifications
import Notifications from 'vue-notification';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
//vuetable-2
import Vuetable from 'vuetable-2';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';
// Import Bootstrap an BootstrapVue CSS files (order is important)
import './styles/app.scss';
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.filter('formatDate', function (value: Date) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
})

// Register Global components

// vue-editable-grid component and styles
const VueEditableGrid = require('vue-editable-grid');
Vue.component('vue-editable-grid', VueEditableGrid);

Vue.component("vuetable", Vuetable);

Vue.component('multiselect', Multiselect)


Vue.use(Notifications, { velocity });


declare module 'vue/types/vue' {
    interface Vue {
        $api: AxiosInstance
    }
}

Vue.component('v-select', vSelect)

let vueInstance;
//Read the config.json file and instantiate the api AxiosInstance
fetch(process.env.BASE_URL + "config.json")
    .then(req => req.json())
    .then(conf => {
        // Reuse shared apiClient but update its baseURL from dynamic config
        apiClient.defaults.baseURL = conf.API_URL;
        Vue.prototype.$api = apiClient;
        Vue.prototype.$api.interceptors.request.use(function (config) {
            const user:User = store.getters.user;
            if (user && user.authenticationToken) {
                config.headers['Content-Type'] = config.headers['Content-Type'] ?? 'application/json' ;
                config.headers['Authorization'] = 'Basic ' + user.authenticationToken;
            }
            else if (user && user.bearerToken) {
                //Check token validity
                const jwtPayload = parseJwt(user.bearerToken);
                if (jwtPayload.exp < Date.now() / 1000) {
                    store.commit('logout');
                    const resolved = router.resolve({
                        name: 'SsoCallBack',
                    });
                    const baseUrl = Vue.prototype.$api?.defaults.baseURL || '';
                    document.location.href = `${baseUrl}auth/authenticate?returnUrl=${document.location.origin}${resolved.href}`;
                }
                config.headers['Content-Type'] = config.headers['Content-Type'] ?? 'application/json';
                config.headers['Authorization'] = 'Bearer ' + user.bearerToken;
            }
            // Do NOT set CORS response headers client-side; browsers may trigger failing preflights.
            return config;
        });
        // 401 handling: redirect to /Auth only once per burst, logout user
        let isRedirecting401 = false;
        Vue.prototype.$api.interceptors.response.use(
            (response) => response,
            async (error: any) => {
                const status = error?.meta?.status || error?.response?.status;
                // Handle 401
                if (status === 401 && !isRedirecting401) {
                    const currentPath = router.currentRoute.path;
                    if (currentPath !== '/Auth') {
                        isRedirecting401 = true;
                        try { store.commit('logout'); } catch (_) {}
                        const returnUrl = window.location.pathname + window.location.search;
                        // Defer navigation to next tick to avoid overlap with in-flight route changes
                        Promise.resolve().then(() => {
                            router.push({ path: '/Auth', query: { returnUrl } })
                                .catch((navErr:any) => {
                                    // Suppress benign navigation cancellation warnings
                                    const msg = navErr && navErr.toString ? navErr.toString() : '';
                                    if (!/Navigation cancelled/i.test(msg)) {
                                        console.warn('Auth redirect navigation issue:', navErr);
                                    }
                                })
                                .finally(() => { isRedirecting401 = false; });
                        });
                    }
                }
                // Network / timeout generic notification
                if (!status) {
                    // Unreachable server or CORS issue
                    const textKey = 'error.serverUnavailable';
                    const text = vueInstance && vueInstance.$t ? vueInstance.$t(textKey).toString() : 'Server unreachable';
                    if (vueInstance && vueInstance.$notify) {
                        vueInstance.$notify({ group: 'globalError', text, type: 'error' });
                    } else {
                        console.error('Server unreachable / network error', error);
                    }
                }
                return Promise.reject(error);
            }
        );
        vueInstance = new Vue({
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app');
    })
    .catch(err => {
        // Fallback: still mount app with default baseURL
        Vue.prototype.$api = apiClient;
        vueInstance = new Vue({
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app');
        console.error('Failed to load config.json, using defaults', err);
    });

// Global Vue error handler for diagnostics (prevents silent blank screen)
Vue.config.errorHandler = (err, vm, info) => {
    console.error('[GlobalError]', info, err);
};
export  function  getVueInstance(){
    return vueInstance;
}
function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};